








































































































































































































































































































































































































































































































import Vue from 'vue';
import moment from 'moment';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import { PendingOrderDetailsResponse } from '@/models/shipments/addOrEdit/responses/PendingOrderDetailsResponse';
import { Account } from '@/models/Account';
import DropdownOption from '@/models/misc/DropdownOption';
import { ShipmentSearch } from '@/models/shipments/search/ShipmentSearch';
import { SmbCarrierParticipating } from '@/models/carriers/SmbCarrierParticipating';
import { SavePendingOrderResponse } from '@/models/shipments/addOrEdit/responses/SavePendingOrderResponse';
import { SimpleQuote } from '@/models/quotes/create/SimpleQuote';
import { SimpleQuoteCharge } from '@/models/quotes/create/SimpleQuoteCharge';

import pendingOrderService from '@/services/PendingOrderService';
import carrierLogoService from '@/services/CarrierLogoService';
import accountsService from '@/services/AccountsService';
import mapsService from '@/services/MapsService';
import containerTypesService from '@/services/ContainerTypesService';
import shipmentsService from '@/services/ShipmentsService';
import carrierService from '@/services/CarrierService';
import settingService from '@/services/SettingService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      showLoadingScreen: false,
      displayConfirmRetract: false,
      retracting: false,
      loadingScreenMessage: '',
      endDate: moment().add(1, 'minutes'),
      order: null as PendingOrderDetailsResponse,
      snackbarText: null,
      snackbar: false,
      account: null as Account,
      mapUrl: null,
      comments: null,
      container: null as DropdownOption,
      smbModel: null as ShipmentSearch,
      carriersParticipating: [] as SmbCarrierParticipating[],
      selectedCarrierOption: null,
      targetRateLocal: null,
      awardAndTenderToBrokerageEnabled: false,
      showSaveShipmentServerErrorsPopup: false,
      saveShipmentServerErrors: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadDetails();
    },
    checkAwardAndTenderToBrokerageEnabled() {
      // only check this setting in Admin Portal
      if (!this.isUserAdminAndNotImpersonating) {
        return;
      }

      const accountId = this.accountId;
      const userId = this.userId;

      settingService
        .getSystemSetting(
          'AWARD_AND_TENDER_TO_BROKERAGE_ENABLED',
          accountId,
          userId
        )
        .then((setting: any) => {
          this.awardAndTenderToBrokerageEnabled =
            setting?.value.toString().toUpperCase() === 'TRUE';
        })
        .catch(() => {
          this.awardAndTenderToBrokerageEnabled = false;
        });
    },
    noResponse(carrier) {
      return (
        this.carrierOptionStatus(carrier) == 'No response' &&
        !this.showAwardCarrierBtn(carrier) &&
        !this.showRetractOfferBtn(carrier) &&
        !this.showAwardAndTenderBtn(carrier)
      );
    },
    showAwardCarrierBtn(carrier) {
      // hide Award button in Admin Portal if AWARD_AND_TENDER_TO_BROKERAGE_ENABLED is true
      if (
        this.isUserAdminAndNotImpersonating &&
        this.awardAndTenderToBrokerageEnabled
      ) {
        return false;
      }

      const result = !carrier.afsAccepted && carrier.offerAmount > 0;
      return result;
    },
    showAwardAndTenderBtn(carrier) {
      // only show in Admin Portal when AWARD_AND_TENDER_TO_BROKERAGE_ENABLED is true
      const result =
        this.isUserAdminAndNotImpersonating &&
        this.awardAndTenderToBrokerageEnabled &&
        !carrier.afsAccepted &&
        carrier.offerAmount > 0;
      return result;
    },
    showRetractOfferBtn(carrier) {
      return carrier.afsAccepted && carrier.offerAmount > 0;
    },
    retractOffer() {
      this.retracting = true;
      var awardedCarrier = this.carriersParticipating.find(
        (x) => x.afsAccepted
      );

      carrierService
        .awardCarrier({
          oppId: awardedCarrier.oppId,
          carrierId: awardedCarrier.carrierIdCode,
          awarded: false,
          shipmentId: this.bidNumber, // should be SM0*
        } as any)
        .finally(() => {
          this.retracting = false;
          this.displayConfirmRetract = false;

          window.location.href = '/carrier/offer-retracted';
        });
    },
    carrierName(carrierName) {
      return carrierName.replace('MANAGEMENT', '');
    },
    logo(carrierName) {
      return carrierLogoService.getLogoPath(carrierName).src;
    },
    carrierOptionStatus(carrier) {
      if (!carrier.responseDate) {
        return 'No response';
      } else if (carrier.responseDate && !carrier.offerAmount) {
        return 'Declined';
      } else {
        const offerAmount = carrier.offerAmount;
        const sortedCarriers = this.carriersParticipating
          .filter((x) => x.offerAmount)
          .sort((a, b) => {
            return a.offerAmount - b.offerAmount;
          });

        if (offerAmount == sortedCarriers[0].offerAmount) {
          return 'Best Value';
        }
      }

      return '';
    },
    loadDetails() {
      let shipmentId = this.bidNumber;
      const bookedShipment = shipmentId.startsWith('SM0');
      if (bookedShipment) {
        shipmentsService
          .search({
            shipmentId: shipmentId,
            isSpotMarket: true,
          } as any)
          .then((x) => {
            shipmentId = x[0].parentId;
            this.populatePageWithShipmentInfo(shipmentId);

            if (x[0].smbExpires) {
              this.endDate = x[0].smbExpires;
            }

            if (x[0]) {
              this.targetRateLocal = x[0].smbTargetRate;
            }
          });

        return;
      }

      if (!shipmentId.startsWith('SM0')) {
        this.populatePageWithShipmentInfo(shipmentId);
      }
    },
    populatePageWithShipmentInfo(shipmentId) {
      this.showLoadingMessage('Loading bid details...');
      pendingOrderService
        .getDetailsById(shipmentId)
        .then((x: PendingOrderDetailsResponse) => {
          this.order = x;

          this.setMap();
          this.setAccount();
          this.setContainerType();

          this.$store.commit('shipments/mapPendingOrderToShipment', x);

          // check system setting after order details are loaded
          this.checkAwardAndTenderToBrokerageEnabled();
        })
        .finally(() => {
          this.stopLoading();
        });

      shipmentsService
        .search({ shipmentId: shipmentId, isSpotMarket: true } as any)
        .then((x) => {
          if (x.length) {
            this.smbModel = x[0];

            // set countdown
            this.endDate = x[0].smbExpires;

            if (x[0]) {
              this.targetRateLocal = x[0].smbTargetRate;
            }
          }
        });

      carrierService
        .getCarriersParticipating(shipmentId)
        .then((x: SmbCarrierParticipating[]) => {
          // don't show duplicates
          this.carriersParticipating = x
            .filter(
              (v, i, a) =>
                a.findIndex((t) => t.carrierIdCode === v.carrierIdCode) === i
            )
            .sort((a, b) => {
              if (a.offerAmount == null) {
                return 1;
              } else if (b.offerAmount == null) {
                return -1;
              } else {
                return (a.offerAmount as any) - (b.offerAmount as any);
              }
            });
        });
    },
    setContainerType() {
      containerTypesService.list().then((x) => {
        const containerId = this.order.pieces[0].containerId;
        this.container = x.find((y) => y.value === containerId);
      });
    },
    showLoadingMessage(message) {
      this.loadingScreenMessage = message;
      this.showLoadingScreen = true;
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.bidNumber);
      this.snackbarText = `Bid number ${this.bidNumber} has been copied to the clipboard`;
      this.snackbar = true;
    },
    setAccount() {
      accountsService.getUser(null, this.order.userId).then((u) => {
        accountsService.getAccountById(u.accountId).then((a) => {
          this.account = a;
        });
      });
    },
    finishBooking(x: SavePendingOrderResponse) {
      if (!x.success) {
        this.saveShipmentServerErrors = x.error;
        this.showSaveShipmentServerErrorsPopup = true;
      } else {
        // redirect to success page or dashboard
        window.location.href = '/customer/spot-market';
      }

      this.stopLoading();
    },
    async finishBookingWithCarrierAward(
      x: SavePendingOrderResponse,
      carrierIdCode: string
    ) {
      if (!x.success) {
        this.saveShipmentServerErrors = x.error;
        this.showSaveShipmentServerErrorsPopup = true;
        this.stopLoading();
        return;
      }

      try {
        let bidNumber = this.bidNumber;
        if (bidNumber.startsWith('SM0') && this.smbModel?.parentId) {
          bidNumber = this.smbModel.parentId;
        }

        const awardRequest = {
          oppId: bidNumber,
          carrierId: carrierIdCode,
          awarded: true,
          shipmentId: x.shipmentId,
        } as any;

        const awardAction = carrierService.awardCarrier(awardRequest);

        const mergeAction =
          shipmentsService.archiveAndMergeOrderWithBookedShipment(
            bidNumber,
            x.shipmentId,
            6
          );

        await Promise.all([awardAction, mergeAction]);

        window.location.href =
          '/customer/spot-market/offer-awarded/' +
          x.shipmentId +
          '/bids/' +
          bidNumber;
      } catch (error) {
        this.catchBookingShipmentError(error);
      } finally {
        this.stopLoading();
      }
    },
    catchBookingShipmentError(x: any) {
      if (x.response && x.response.data && x.response.data.message) {
        this.saveShipmentServerErrors = x.response.data.message;
      } else if (x) {
        this.saveShipmentServerErrors = x;
      } else {
        this.saveShipmentServerErrors = 'Sorry, something went wrong';
      }

      this.showSaveShipmentServerErrorsPopup = true;
      this.stopLoading();
    },
    award(carrier) {
      if (
        this.carriersParticipating.some(
          (p) => p.afsAccepted && p.offerAmount > 0
        )
      ) {
        this.snackbar = true;
        this.snackbarText =
          'You have already awarded a carrier. Before awarding another carrier, you must retract the previous award.';
        return;
      }

      this.showLoadingMessage('Confirming offer...');

      if (this.saveShipmentRequest.pickupWindow) {
        this.saveShipmentRequest.pickupWindow.date = moment(
          this.saveShipmentRequest.pickupWindow.date
        ).format('YYYY-MM-DD');
      }

      if (this.saveShipmentRequest.deliveryWindow) {
        this.saveShipmentRequest.deliveryWindow.date = moment(
          this.saveShipmentRequest.deliveryWindow.date
        ).format('YYYY-MM-DD');
      }

      this.saveShipmentRequest.selectedRate = new SimpleQuote();
      this.saveShipmentRequest.selectedRate.contractId = carrier.contractId;
      this.saveShipmentRequest.selectedRate.carrierId = carrier.carrierIdCode;
      this.saveShipmentRequest.selectedRate.scac = carrier.scac;
      this.saveShipmentRequest.selectedRate.carrierName = carrier.carrierName;
      this.saveShipmentRequest.selectedRate.baseRate = carrier.offerAmount;
      this.saveShipmentRequest.selectedRate.fuelSurcharge = 0;
      this.saveShipmentRequest.selectedRate.totalRate = carrier.offerAmount;
      this.saveShipmentRequest.selectedRate.sellBaseRate = carrier.offerAmount;
      this.saveShipmentRequest.selectedRate.sellFuelSurcharge = 0;
      this.saveShipmentRequest.selectedRate.sellTotalRate = carrier.offerAmount;
      this.saveShipmentRequest.selectedRate.charges = [
        {
          accChargeId: 8,
          charge: 0,
          sellCharge: 0,
        } as any,
        {
          accChargeId: 23,
          charge: carrier.offerAmount,
          sellCharge: carrier.offerAmount,
        } as any,
      ];

      shipmentsService
        .book(this.saveShipmentRequest)
        .then((x: SavePendingOrderResponse) => {
          this.finishBookingWithCarrierAward(x, carrier.carrierIdCode);
        })
        .catch((x) => {
          this.catchBookingShipmentError(x);
        });
    },
    awardAndTenderToBrokerage(carrier) {
      if (
        this.carriersParticipating.some(
          (p) => p.afsAccepted && p.offerAmount > 0
        )
      ) {
        this.snackbar = true;
        this.snackbarText =
          'You have already awarded a carrier. Before awarding another carrier, you must retract the previous award.';
        return;
      }

      this.showLoadingMessage('Awarding & Tendering to Brokerage...');

      if (this.saveShipmentRequest.pickupWindow) {
        this.saveShipmentRequest.pickupWindow.date = moment(
          this.saveShipmentRequest.pickupWindow.date
        ).format('YYYY-MM-DD');
      }

      if (this.saveShipmentRequest.deliveryWindow) {
        this.saveShipmentRequest.deliveryWindow.date = moment(
          this.saveShipmentRequest.deliveryWindow.date
        ).format('YYYY-MM-DD');
      }

      // set up selectedRate with AFS Advantage details for tendering to brokerage
      this.saveShipmentRequest.selectedRate = new SimpleQuote();
      this.saveShipmentRequest.selectedRate.carrierId = 'CM00021903';
      this.saveShipmentRequest.selectedRate.carrierName = 'AFS Advantage';
      this.saveShipmentRequest.selectedRate.contractId = 11278; // spot contract
      this.saveShipmentRequest.selectedRate.contractType = 11278; // spot contract
      this.saveShipmentRequest.selectedRate.currency = 'USD';
      this.saveShipmentRequest.selectedRate.description = 'AFSA';
      this.saveShipmentRequest.selectedRate.scac = 'AFSA';
      this.saveShipmentRequest.selectedRate.baseRate = carrier.offerAmount;
      this.saveShipmentRequest.selectedRate.fuelSurcharge = 0;
      this.saveShipmentRequest.selectedRate.totalRate = carrier.offerAmount;
      this.saveShipmentRequest.selectedRate.sellBaseRate = carrier.offerAmount;
      this.saveShipmentRequest.selectedRate.sellFuelSurcharge = 0;
      this.saveShipmentRequest.selectedRate.sellTotalRate = carrier.offerAmount;
      this.saveShipmentRequest.selectedRate.charges = [
        {
          accChargeId: 8,
          charge: 0,
          sellCharge: 0,
        } as any,
        {
          accChargeId: 23,
          charge: carrier.offerAmount,
          sellCharge: carrier.offerAmount,
        } as any,
      ];

      // save actual carrier selection in shipment references
      // reference type id = 92, reference name = "Carrier Name", reference value = selected carrier name
      const carrierNameReference = {
        id: 92,
        description: 'Carrier Name',
        reference: carrier.carrierName,
        createdBy: 'system',
        createdDate: this.now(),
      };

      // add or update the carrier name reference
      if (!this.saveShipmentRequest.references) {
        this.saveShipmentRequest.references = [];
      }

      // remove any existing carrier name reference
      this.saveShipmentRequest.references =
        this.saveShipmentRequest.references.filter((ref) => ref.id !== 92);

      // add the new carrier name reference
      this.saveShipmentRequest.references.push(carrierNameReference);

      // set the tenderToBrokerage flag
      this.saveShipmentRequest.tenderToBrokerage = true;

      shipmentsService
        .book(this.saveShipmentRequest)
        .then((x: SavePendingOrderResponse) => {
          this.finishBookingWithCarrierAward(x, carrier.carrierIdCode);
        })
        .catch((x) => {
          this.catchBookingShipmentError(x);
        });
    },
    stopLoading() {
      this.loadingScreenMessage = '';
      this.showLoadingScreen = false;
    },
    goBack() {
      window.location.href = '/customer/spot-market';
    },
    setMap() {
      mapsService
        .getImagePathAsync(
          this.order.origPostalCode,
          this.order.destPostalCode,
          [],
          this.displayEmail,
          null
        )
        .then((x) => {
          this.mapUrl = x;
        });
    },
    statusColor(status) {
      switch (status) {
        case 'Bids in Progress':
          return '#ffdbe2';
        case 'Ready Bids':
          return '#ffdeb8';
        case 'Awarded':
          return '#6639C2';
        case 'Pending':
        default:
          return '#7FC4FD';
      }
    },
    statusTextColor(status) {
      switch (status) {
        case 'Bids in Progress':
          return '#f6123a';
        case 'Ready Bids':
          return '#d64514';
        case 'Awarded':
          return '#f0f0f0';
        case 'Pending':
        default:
          return '#fff';
      }
    },
  },
  computed: {
    accountId() {
      if (this.isUserAdminAndNotImpersonating && this.order) {
        return this.order.accountId;
      }
      return this.user?.accountId;
    },
    userId() {
      if (this.isUserAdminAndNotImpersonating && this.order) {
        return this.order.userId;
      }
      return this.user?.userId;
    },
    bidNumber() {
      return this.$route.params.bidId;
    },
    endDateComputed() {
      return this.endDate;
    },
    orig() {
      return this.order.stops[1];
    },
    dest() {
      return this.order.stops[0];
    },
    piece() {
      return this.order.pieces[0];
    },
    weightPerPiece() {
      return this.piece.weight;
    },
    length() {
      return this.piece.length;
    },
    numberOfPieces() {
      let total = 0;
      this.order.pieces.forEach((x) => {
        total += x.pieces;
      });

      return total;
    },
    totalWeight() {
      let total = 0;
      this.order.pieces.forEach((x) => {
        total += x.weight;
      });

      return total;
    },
    width() {
      return this.piece.width;
    },
    height() {
      return this.piece.height;
    },
    referenceNumber() {
      return this.order.references?.length
        ? this.order.references[0].reference
        : 'N/A';
    },
    targetRate() {
      return !this.targetRateLocal
        ? '$0.00 USD'
        : '$' + this.formatMoney(this.targetRateLocal) + ' USD';
    },
    estimatedPickup() {
      const date = this.order.estPickupDate;

      const orig = this.order.stops.find((x) => x.stopType == 'ORIG');
      let time = null;
      if (orig?.apptTimeStart) {
        time = ' at ' + orig.apptTimeStart.trim() + ' CST';
      }

      return this.formatDate(date) + time;
    },
    estimatedDelivery() {
      const date = this.order.requestedDeliveryDate;

      const dest = this.order.stops.find((x) => x.stopType == 'DEST');
      let time = null;
      if (dest?.apptTimeStart) {
        time = ' at ' + dest.apptTimeStart.trim() + ' CST';
      }

      if (date) {
        return this.formatDate(date) + time;
      }

      return 'Not Determined';
    },
    saveShipmentRequest() {
      return this.$store.state.shipments.saveShipmentForm;
    },
    offersAmount() {
      return this.carriersParticipating.filter(
        (x) => x.offerAmount && x.responseDate
      ).length;
    },
    bidStatus() {
      if (
        this.bidNumber.startsWith('SM0') &&
        this.carriersParticipating.find((x) => x.afsAccepted)
      ) {
        return 'Awarded';
      }

      if (this.smbModel && this.smbModel.smbBidStatus) {
        return this.smbModel.smbBidStatus;
      }

      return 'Pending';
    },
  },
});
